import './vendor';

import './components/chatbot';
import './components/simplebar';
import './components/mask';
